export default "__VITE_ASSET__DZbIPFhY__"